import { render, staticRenderFns } from "./rightBot.vue?vue&type=template&id=9a6b0f96&scoped=true&lang=true&"
import script from "./rightBot.vue?vue&type=script&lang=js&"
export * from "./rightBot.vue?vue&type=script&lang=js&"
import style0 from "./rightBot.vue?vue&type=style&index=0&id=9a6b0f96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6b0f96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a6b0f96')) {
      api.createRecord('9a6b0f96', component.options)
    } else {
      api.reload('9a6b0f96', component.options)
    }
    module.hot.accept("./rightBot.vue?vue&type=template&id=9a6b0f96&scoped=true&lang=true&", function () {
      api.rerender('9a6b0f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/ssztDrawer/rightBar/rightBot.vue"
export default component.exports